import { DateUnit } from "./date-unit";

export const DurationDate = DateUnit;
export type DurationDate = DateUnit;
